<template>
  <div id="app">
      <div class="content">
          <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">-->
              <router-view/>
          </transition>
      </div>
  </div>
</template>
<script>

    export default {
        name: 'app',
        mounted(){

            sessionStorage.setItem('firstUrl',window.location.href);
        }
    }
</script>
<style>
  .picker-items { width: 100% !important; }
</style>



// WEBPACK FOOTER //
// src/App.vue